import React from 'react';
import { motion } from 'framer-motion';
import { ZapIcon, ArrowDownIcon } from 'lucide-react';
import { useCurrencyByIP } from '../../hooks/useCurrencyByIP';
export function PromoBanner() {
  const {
    price,
    originalPrice
  } = useCurrencyByIP();
  return <motion.div initial={{
    opacity: 0,
    y: -20
  }} animate={{
    opacity: 1,
    y: 0
  }} transition={{
    duration: 0.5,
    ease: [0.25, 0.1, 0.25, 1]
  }} className="relative w-full px-4 pt-4 md:pt-6 pb-2" data-id="element-575">
      <div className="max-w-3xl mx-auto" data-id="element-576">
        <div className="relative overflow-hidden bg-accent/10 border-2 border-accent/40 rounded-2xl p-5 md:p-7 text-center" data-id="element-577">
          {/* Background glow */}
          <div className="absolute inset-0 pointer-events-none" style={{
          background: 'radial-gradient(ellipse at center, rgba(255,107,0,0.08) 0%, transparent 70%)'
        }} data-id="element-578" />

          <div className="relative" data-id="element-579">
            {/* Badge */}
            <div className="inline-flex items-center gap-1.5 bg-accent/20 border border-accent/30 rounded-full px-3 py-1 mb-3" data-id="element-580">
              <ZapIcon className="w-3.5 h-3.5 text-accent" data-id="element-581" />
              <span className="text-[10px] md:text-xs font-bold text-accent uppercase tracking-widest" data-id="element-582">
                Super Promo
              </span>
            </div>

            <p className="text-base md:text-lg text-white font-bold leading-snug mb-2" data-id="element-583">
              🔥 ¡Nos volvimos locos! Como agradecimiento por tus compras hemos
              bajado los precios de todos nuestros productos a tan solo{' '}
              <span className="text-accent font-extrabold" data-id="element-584">{price}</span>
            </p>

            {/* Old price tachado */}
            <p className="text-sm text-neutral-400 mb-3" data-id="element-585">
              Antes:{' '}
              <span className="line-through font-bold" data-id="element-586">{originalPrice}</span>
            </p>

            <p className="text-sm text-amber-400/80 font-semibold mb-4" data-id="element-587">
              ⚡ Aprovecha, se acaba pronto — Solo por esta semana
            </p>

            <a href="#pricing" className="inline-flex items-center gap-2 bg-gradient-to-r from-accent to-accent-light text-white font-bold text-sm md:text-base py-3 px-6 md:px-8 rounded-xl animate-pulse-glow transition-transform duration-200 hover:scale-[1.03] active:scale-[0.98] no-underline" data-id="element-588">
              <span data-id="element-589">Ver oferta — {price}</span>
              <ArrowDownIcon className="w-4 h-4" data-id="element-590" />
            </a>
          </div>
        </div>
      </div>
    </motion.div>;
}